import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import {
  takeUntil
} from 'rxjs/operators';
import Swal from 'sweetalert2';
import { environment } from '../../../../environments/environment.prod';
import { AlmacenService } from '../../../services/Almacen/almacen.service';
import { EmpresaService } from '../../../services/Empresa/Empresa.service';
import { LoginService } from '../../../services/login/login.service';

export interface DataFile {
  message?: string;
  archivos?: Array<{}>;
}

export interface User {
  name: string;
}

@Component({
  selector: 'app-otros-proveedores-guias',
  templateUrl: './otros-proveedores-guias.component.html',
  styleUrls: ['./otros-proveedores-guias.component.scss'],
})
export class otrosProveedoresGuiasComponent implements OnInit {
  empresaId = String(environment.empresaId);
  private destroy$ = new Subject<void>();

  constructor(
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private almacenService: AlmacenService,
    private empresaService: EmpresaService
  ) {
    this.empresaService.empresaId$
      .pipe(takeUntil(this.destroy$))
      .subscribe(id => {
        this.empresaId = id;
      });
  }
  public form: FormGroup;
  public formData = new FormData();
  // Each element is an array of files per guide
  public dataFiles: File[][] = [[], [], [], [], [], []];
  private unsubscribe$ = new Subject<void>();
  public listProveedores = [
    { value: 'DHL' },
    { value: 'INBOX' },
    { value: 'PAQUETE EXPRESS' },
    { value: 'ESTAFETA' },
    { value: 'OTRA PAQUETERIA' },
  ];
  @Input() aditionalInfo = null;
  @Input() data = null;
  @Output() closeModalGuia: EventEmitter<boolean> = new EventEmitter();

  ngOnInit() {
    console.log('<<>>>', this.data)
    this.spinner.hide('spinner-guia');
    this.buildForm();
  }
  private buildForm = (): void => {
    // Inicializamos el formulario, usando formBuilder para crear un array de formGroups para cada guia
    this.form = this.formBuilder.group({
      proveedor: ['', [Validators.required, Validators.minLength(3)]],
      otroProveedor: [''],
      guias: this.formBuilder.array(Array.from({ length: 6 }, (_, i) =>
        this.formBuilder.group({
          guia: ['', []],
          file: [null, []]
        })
      ))
    });
    // Validamos que si el campo guia tiene un valor, el campo file sea requerido
    this.guiasFormArray.forEach((group: FormGroup, idx: number) => {
      group.get('guia').valueChanges.subscribe(val => {
        if (val && val.length > 0) {
          group.get('file').setValidators([Validators.required]);
        } else {
          group.get('file').clearValidators();
        }
        group.get('file').updateValueAndValidity({ emitEvent: false });
      });
    });
  }

  onProveedorChange = (event: any): void => {
    if (event.value == 'OTRA PAQUETERIA') {
      this.form.get('otroProveedor').setValidators([Validators.required]);
    } else {
      this.form.get('otroProveedor').clearValidators();
    }
    this.form.get('otroProveedor').updateValueAndValidity({ emitEvent: false });
  };

  get guiasFormArray() {
    return this.form.get('guias')['controls'];
  }
  /**
  * Metodo para seleccionar el file del dropzone
  * @param event evento que emite el DropZone, devuelve los datos del archivo
  */
  // index es el indice de la guia (0-5)
  public fileSelect = (event, index: number): void => {
    const files = event.addedFiles;
    if (files[0].size > 2000000) {
      Swal.fire({
        type: 'warning',
        title: 'Alta de cliente',
        html: 'El tamaño del archivo debe ser menor a 2MB',
        confirmButtonText: 'Aceptar',
        footer:
          'Contáctanos&nbsp;<a href="mailto:incidencias@integradora.net">incidencias@integradora.net</a>',
      });
      this.dataFiles[index] = [];
      this.guiasFormArray[index].get('file').setValue(null);
      return;
    }
    if (files && files.length > 0) {
      this.dataFiles[index] = files;
      this.guiasFormArray[index].get('file').setValue(files[0]);
      this.successDropZone(index);
    }
  };

  // Metodo para agregar la clase drop-zone-success al dropzone
  private successDropZone = (index: number) => {
    console.log('successDropZone', index);
    const dropzone = document.getElementsByClassName('drop-zone-' + index);
    if (dropzone) {
      console.log('dropzone', dropzone);
      dropzone[0].classList.add('drop-zone-success');
      dropzone[0].classList.remove('drop-zone-error');
    }
  };

  // Metodo para agregar la clase drop-zone-error al dropzone
  private errorDropZone = (index: number) => {
    const dropzone = document.getElementsByClassName('drop-zone-' + index);
    if (dropzone) {
      dropzone[0].classList.add('drop-zone-error');
      dropzone[0].classList.remove('drop-zone-success');
    }
  };

  // Metodo para eliminar el archivo del dropzone
  public fileRemove = (event, index: number): void => {
    this.dataFiles[index] = [];
    this.guiasFormArray[index].get('file').setValue(null);
    const dropzone = document.getElementsByClassName('drop-zone-' + index);
    if (dropzone) {
      dropzone[0].classList.remove('drop-zone-success');
      dropzone[0].classList.remove('drop-zone-error');
    }
  };

  public onSubmit = (): void => {
    // Validamos que si el campo guia tiene un valor, el campo file sea requerido
    let valid = true;
    this.guiasFormArray.forEach((group: FormGroup, idx: number) => {
      const guia = group.get('guia').value;
      const file = group.get('file').value;
      if (guia && !file) {
        group.get('file').setErrors({ required: true });
        this.errorDropZone(idx);
        valid = false;
      }
    });
    // Validamos que el formulario sea válido y que valid sea true
    if (this.form.valid && valid) {
      const guiasToUpload = this.guiasFormArray
        .map((group: FormGroup, idx: number) => {
          const guia = group.get('guia').value;
          const file = group.get('file').value;
          return guia && file ? { guia, file } : null;
        })
        .filter(item => !!item);
      // Validamos que al menos se suba una guia
      if (guiasToUpload.length === 0) {
        Swal.fire({
          type: 'warning',
          title: 'Aviso',
          text: 'Debes ingresar al menos una guía.',
          confirmButtonText: 'Aceptar',
        });
        return;
      }
      this.spinner.show('spinner-guia');
      let successCount = 0;
      const failedGuias: string[] = [];
      const total = guiasToUpload.length;
      // Funcion recursiva para subir las guias
      const uploadGuide = (index: number) => {
        if (index >= total) {
          this.spinner.hide('spinner-guia');
          Swal.fire({
            type: successCount === total ? 'success' : (successCount > 0 ? 'warning' : 'error'),
            title: 'Carga de guías',
            html: `${successCount} guías cargadas${failedGuias.length ? ', las guías: <b>' + failedGuias.join(', ') + '</b> no se subieron' : ''}`,
            confirmButtonText: 'Aceptar',
          });
          if (successCount > 0) {
            this.closeModalGuia.emit(true);
          }
          return;
        }
        const { guia, file } = guiasToUpload[index];
        const formData = new FormData();
        const proveedorGuia = this.form.get('proveedor').value == 'OTRA PAQUETERIA' ? this.form.get('otroProveedor').value : this.form.get('proveedor').value;
        formData.append('files[]', file, file.name);
        formData.append('empresa', String(this.empresaId));
        formData.append('proveedorGuia', proveedorGuia);
        formData.append('almacenId', this.aditionalInfo.almacen);
        formData.append('pedidoId', this.aditionalInfo.pedido);
        formData.append('guia', guia);
        formData.append('option', 'setOtrosEnvios');
        formData.append('quien', this.loginService.getUserData().correo);
        formData.append('cliente', this.aditionalInfo.cliente);
        formData.append('tipo', 'Pedido');
        this.almacenService
          .setProveedorGuia(formData)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((responseUploadFile) => {
            if (responseUploadFile.status === 'success') {
              successCount++;
            } else {
              failedGuias.push(guia);
            }
            uploadGuide(index + 1);
          }, () => {
            failedGuias.push(guia);
            uploadGuide(index + 1);
          });
      };
      uploadGuide(0);
    } else {
      this.form.markAllAsTouched();
    }
  };



  /**
   * Obtenemos el archivo file y lo almacenamos en un FromData con el RFC y el nombre de la empresa
   */
  public getFile = (): void => {
    const proveedorGuia = this.form.get('proveedor').value == 'OTRA PAQUETERIA' ? this.form.get('otroProveedor').value : this.form.get('proveedor').value;
    const empresaId = this.empresaId;
    const file: File[][] = this.dataFiles;
    this.formData.append('files[]', file[0][0], file[0][0].name);
    this.formData.append('empresa', String(empresaId));
    this.formData.append('proveedorGuia', proveedorGuia);
    this.formData.append('almacenId', this.aditionalInfo.almacen);
    this.formData.append('pedidoId', this.aditionalInfo.pedido);
    this.formData.append('guia', this.form.get('guia').value);
    this.formData.append('option', 'setOtrosEnvios');
    this.formData.append('quien', this.loginService.getUserData().correo);
    this.formData.append('cliente', this.aditionalInfo.cliente);
    this.formData.append('tipo', 'Pedido');
  };

  // Funcion para abrir el dropzone dando click en el boton
  clickDropZone = (index: number) => {
    const dropzone = document.getElementById('drop-zone-rfc-' + index);
    if (dropzone) {
      dropzone.click();
    }
  }
}
